import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "result"]
  static values = { url: String, label: String, testing: String, failed: String }

  async test() {
    this.buttonTarget.disabled = true
    this.buttonTarget.textContent = this.testingValue
    this.resultTarget.style.display = "none"

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
          "Accept": "application/json"
        }
      })
      const data = await response.json()
      this.resultTarget.className = "mt-3 alert " + (data.success ? "alert-success" : "alert-danger")
      this.resultTarget.textContent = data.message
      this.resultTarget.style.display = "block"
    } catch (e) {
      this.resultTarget.className = "mt-3 alert alert-danger"
      this.resultTarget.textContent = this.failedValue
      this.resultTarget.style.display = "block"
    } finally {
      this.buttonTarget.disabled = false
      this.buttonTarget.textContent = this.labelValue
    }
  }
}
